(function(){
"use strict";
var rm=window.matchMedia("(prefers-reduced-motion: reduce)").matches;

function reveal(){
  var items=[].slice.call(document.querySelectorAll(".ci-rv:not(.is-in)"));
  if(!items.length)return;
  if(!("IntersectionObserver" in window)){items.forEach(function(n){n.classList.add("is-in")});return}
  var io=new IntersectionObserver(function(es){
    es.forEach(function(e){if(e.isIntersecting){e.target.classList.add("is-in");io.unobserve(e.target)}})
  },{threshold:.1,rootMargin:"0px 0px -6% 0px"});
  items.forEach(function(n){io.observe(n)});
}

function parallax(){
  var hero=document.querySelector(".ci-hero");
  if(!hero||rm)return;
  if(!window.matchMedia("(hover:hover) and (pointer:fine)").matches)return;
  var ls=[].slice.call(hero.querySelectorAll("[data-depth]"));
  if(!ls.length)return;
  var tx=0,ty=0,cx=0,cy=0,raf=0;
  function loop(){
    cx+=(tx-cx)*.08; cy+=(ty-cy)*.08;
    for(var i=0;i<ls.length;i++){
      var d=+ls[i].getAttribute("data-depth")||0;
      ls[i].style.translate=(cx*d).toFixed(1)+"px "+(cy*d).toFixed(1)+"px";
    }
    if(Math.abs(tx-cx)>.001||Math.abs(ty-cy)>.001){raf=requestAnimationFrame(loop)}else{raf=0}
  }
  window.addEventListener("pointermove",function(e){
    var r=hero.getBoundingClientRect();
    tx=Math.max(-1,Math.min(1,(e.clientX-(r.left+r.width/2))/r.width*2));
    ty=Math.max(-1,Math.min(1,(e.clientY-(r.top+r.height/2))/r.height*2));
    if(!raf)raf=requestAnimationFrame(loop);
  },{passive:true});
}

function heroDrift(){
  var stage=document.querySelector(".ci-hero__stage");
  if(!stage||rm||stage.closest("[data-ci-split]"))return;
  var vh=window.innerHeight,ticking=false;
  function run(){
    ticking=false;
    var y=window.pageYOffset;
    if(y<vh*1.15){
      stage.style.transform="translate3d(0,"+(y*.11).toFixed(1)+"px,0)";
      stage.style.opacity=(1-y/(vh*.9)).toFixed(3);
    }
  }
  window.addEventListener("scroll",function(){if(!ticking){ticking=true;requestAnimationFrame(run)}},{passive:true});
  window.addEventListener("resize",function(){vh=window.innerHeight},{passive:true});
  run();
}

function stickyBar(){
  var bar=document.querySelector(".ci-stickybar");
  if(!bar)return;
  var anchor=document.querySelector("[data-ci-buy]");
  var vh=window.innerHeight,ticking=false,shown=false;
  function run(){
    ticking=false;
    var on=shown;
    if(anchor){
      var r=anchor.getBoundingClientRect();
      if(!shown&&r.bottom<-20)on=true;
      if(shown&&r.bottom>40)on=false;
    }else{
      var y=window.pageYOffset;
      if(!shown&&y>vh*.9)on=true;
      if(shown&&y<vh*.7)on=false;
    }
    if(on!==shown){shown=on;bar.classList.toggle("is-on",on)}
  }
  window.addEventListener("scroll",function(){if(!ticking){ticking=true;requestAnimationFrame(run)}},{passive:true});
  window.addEventListener("resize",function(){vh=window.innerHeight;run()},{passive:true});
  run();
}

function anchors(){
  document.addEventListener("click",function(e){
    var a=e.target.closest?e.target.closest('a[href^="#"]:not([href="#"])'):null;
    if(!a)return;
    var t=null;
    try{t=document.querySelector(a.getAttribute("href"))}catch(err){return}
    if(!t)return;
    e.preventDefault();
    t.scrollIntoView({behavior:rm?"auto":"smooth",block:"start"});
  });
}

function gallery(){
  var root=document.querySelector("[data-ci-gallery]");
  if(!root)return;
  var main=root.querySelector("[data-ci-gallery-main]");
  if(!main)return;
  root.addEventListener("click",function(e){
    var b=e.target.closest?e.target.closest("[data-ci-thumb]"):null;
    if(!b)return;
    var src=b.getAttribute("data-src"),srcset=b.getAttribute("data-srcset");
    if(src)main.src=src;
    if(srcset)main.srcset=srcset;
    var all=root.querySelectorAll("[data-ci-thumb]");
    for(var i=0;i<all.length;i++)all[i].setAttribute("aria-current","false");
    b.setAttribute("aria-current","true");
  });
}

function init(){
  reveal();parallax();heroDrift();stickyBar();anchors();gallery();
}
if(document.readyState==="loading"){document.addEventListener("DOMContentLoaded",init)}else{init()}
document.addEventListener("shopify:section:load",init);
})();

(function(){
  var FALLBACK=15;
  function limit(){var n=parseInt(window.ciMaxQty,10);return n>0?n:FALLBACK}
  function fieldOf(el){
    var w=el.closest?el.closest(".js-qty__wrapper"):null;
    return w?w.querySelector(".js-qty__num"):null;
  }
  function note(w,max){
    if(!w)return;
    var host=w.parentNode;
    if(!host)return;
    var n=host.querySelector("[data-qty-limit]");
    if(!n){
      n=document.createElement("div");
      n.className="ci-qtynote ci-qtynote--limit";
      n.setAttribute("data-qty-limit","");
      host.appendChild(n);
    }
    n.textContent="Maximal "+max+" pro Bestellung";
  }
  document.addEventListener("click",function(e){
    var t=e.target;
    var btn=t&&t.closest?t.closest(".js-qty__adjust--plus"):null;
    if(!btn)return;
    var inp=fieldOf(btn);
    if(!inp)return;
    var max=limit();
    if(parseInt(inp.value,10)>=max){
      e.preventDefault();
      e.stopPropagation();
      inp.value=max;
      note(btn.closest(".js-qty__wrapper"),max);
    }
  },true);
  document.addEventListener("change",function(e){
    var t=e.target;
    if(!t||!t.classList||!t.classList.contains("js-qty__num"))return;
    var max=limit();
    var v=parseInt(t.value,10);
    if(!isNaN(v)&&v>max){
      t.value=max;
      note(t.closest(".js-qty__wrapper"),max);
    }
  },true);
})();
(function(){
  function init(){
    document.querySelectorAll("[data-ci-split]").forEach(function(sp){
      if(sp.dataset.spReady)return;
      sp.dataset.spReady="1";
      var fine=window.matchMedia&&window.matchMedia("(hover:hover) and (pointer:fine)").matches;
      if(!fine)return;
      var state="",raf=0,lastX=-1;
      var shift=function(){
        var w=sp.clientWidth;
        return Math.round(Math.min(120,Math.max(70,w*0.075)));
      };
      var set=function(k){
        if(k===state)return;
        state=k;
        sp.classList.remove("is-a","is-b");
        if(k){sp.classList.add("is-"+k)}
        sp.style.setProperty("--spShift",(k==="a"?shift():k==="b"?-shift():0)+"px");
      };
      var judge=function(){
        raf=0;
        if(sp.classList.contains("is-intro")||lastX<0)return;
        var r=sp.getBoundingClientRect();
        var band=Math.min(300,Math.max(120,r.width*0.15));
        var cur=state==="a"?shift():state==="b"?-shift():0;
        var mid=r.left+r.width/2+cur;
        var dead=band/2+18;
        if(lastX<mid-dead)set("a");
        else if(lastX>mid+dead)set("b");
      };
      sp.addEventListener("mousemove",function(e){
        lastX=e.clientX;
        if(!raf)raf=requestAnimationFrame(judge);
      });
      sp.addEventListener("mouseleave",function(){lastX=-1;set("")});
      sp.querySelectorAll("[data-sp-side]").forEach(function(side){
        var k=side.getAttribute("data-sp-side");
        side.addEventListener("focus",function(){if(!sp.classList.contains("is-intro"))set(k)});
        side.addEventListener("blur",function(){set("")});
      });
    });
    fit();
    document.querySelectorAll("[data-ci-split].is-intro").forEach(intro);
  }
  var held=[];
  function looksLikeBanner(el){
    if(!el||el.nodeType!==1)return false;
    if(el.closest("[data-ci-split],#CartDrawer,#NavDrawer,#HeaderWrapper,#shopify-section-header"))return false;
    var t=(el.textContent||"").slice(0,4000).toLowerCase();
    return /cookie|datenschutz|consent|privacy/.test(t);
  }
  function fixedIn(el){
    var p=getComputedStyle(el).position;
    if(p==="fixed"||p==="sticky")return el;
    var all=el.querySelectorAll("*");
    for(var i=0;i<all.length&&i<300;i++){
      p=getComputedStyle(all[i]).position;
      if(p==="fixed"||p==="sticky")return all[i];
    }
    return null;
  }
  function hold(el){
    if(!el||held.indexOf(el)>-1)return;
    el.style.setProperty("visibility","hidden","important");
    el.style.setProperty("opacity","0","important");
    held.push(el);
  }
  function releaseBanners(){
    document.documentElement.classList.remove("kk-cut");
    held.forEach(function(el){
      el.style.setProperty("transition","opacity .5s ease","important");
      el.style.removeProperty("visibility");
      el.style.removeProperty("opacity");
    });
    held=[];
    if(window.__kkMo){window.__kkMo.disconnect();window.__kkMo=null}
  }
  function holdBanners(){
    if(!document.documentElement.classList.contains("kk-cut"))return;
    Array.prototype.forEach.call(document.body.children,function(el){
      if(looksLikeBanner(el)){var f=fixedIn(el);if(f)hold(f)}
    });
    if(window.MutationObserver&&!window.__kkMo){
      window.__kkMo=new MutationObserver(function(muts){
        if(!document.documentElement.classList.contains("kk-cut"))return;
        muts.forEach(function(m){
          Array.prototype.forEach.call(m.addedNodes,function(n){
            if(n.nodeType!==1||!looksLikeBanner(n))return;
            var f=fixedIn(n);if(f)hold(f);
            setTimeout(function(){var g=fixedIn(n);if(g)hold(g)},300);
          });
        });
      });
      window.__kkMo.observe(document.body,{childList:true,subtree:true});
    }
    setTimeout(releaseBanners,9000);
  }
  function intro(sp){
    var mode=sp.getAttribute("data-intro")||"always";
    var rm=window.matchMedia&&window.matchMedia("(prefers-reduced-motion:reduce)").matches;
    var seen=false;
    try{seen=mode==="session"&&sessionStorage.getItem("kkCut")==="1"}catch(e){}
    if(rm||seen||sp.dataset.cutDone){sp.classList.remove("is-intro");releaseBanners();return}
    sp.dataset.cutDone="1";
    holdBanners();
    var done=false;
    var finish=function(){
      if(done)return;done=true;
      sp.classList.add("is-open");
      sp.classList.remove("is-intro","is-cut","is-ready");
      setTimeout(releaseBanners,900);
      setTimeout(function(){sp.classList.remove("is-open")},1200);
      try{sessionStorage.setItem("kkCut","1")}catch(e){}
    };
    var start=function(){
      requestAnimationFrame(function(){
        sp.classList.add("is-cut");
        setTimeout(function(){sp.classList.add("is-open")},1650);
        var m=sp.querySelector(".ci-sp__cm");
        if(m)m.addEventListener("animationend",function(e){if(e.animationName.indexOf("spOpen")===0)setTimeout(finish,40)});
        setTimeout(finish,3400);
      });
    };
    var t0=Date.now();
    var urls=[];
    ["a","b"].forEach(function(k){
      var bg=sp.querySelector(".ci-sp__bg--"+k);
      if(!bg)return;
      var m=/url\(["']?([^"')]+)["']?\)/.exec(getComputedStyle(bg).backgroundImage||"");
      if(m)urls.push(m[1]);
    });
    var sels=[".ci-sp__side--a .ci-sp__mark",".ci-hero__bird img",".ci-hero__sub",".ci-sp__tear--v",".ci-sp__tear--h",".ci-sp__blade",".ci-sp__razor",".ci-sp__mark--por",".ci-sp__orbit .ci-fl img",".ci-sp__orbit--b .ci-fl img",".ci-sp__veil img"];
    var waits=[];
    sels.forEach(function(s){
      var i=sp.querySelector(s);
      if(!i||!getComputedStyle(i).display||getComputedStyle(i.parentElement).display==="none")return;
      if(i.decode){waits.push(i.decode().catch(function(){}))}
      else if(!i.complete){waits.push(new Promise(function(r){i.addEventListener("load",r,{once:true});i.addEventListener("error",r,{once:true})}))}
    });
    urls.forEach(function(u){
      waits.push(new Promise(function(r){var im=new Image();im.onload=im.onerror=r;im.src=u;if(im.decode){im.decode().then(r,r)}}));
    });
    var ready=function(){
      var rest=Math.max(0,700-(Date.now()-t0));
      setTimeout(function(){
        sp.classList.add("is-ready");
        setTimeout(start,700);
      },rest);
    };
    var readyOnce=false;
    var go=function(){if(readyOnce)return;readyOnce=true;ready()};
    Promise.all(waits).then(go,go);
    setTimeout(go,2600);
  }
  function fit(){
    var sp=document.querySelector("[data-ci-split]");
    if(!sp)return;
    var t=Math.round(sp.getBoundingClientRect().top+(window.pageYOffset||0));
    if(t<0)t=0;
    if(t>240)t=240;
    document.documentElement.style.setProperty("--spHead",t+"px");
  }
  if(document.readyState==="loading"){document.addEventListener("DOMContentLoaded",init)}else{init()}
  document.addEventListener("shopify:section:load",init);
  window.addEventListener("resize",function(){clearTimeout(window.__spT);window.__spT=setTimeout(fit,150)});
  window.addEventListener("load",fit);
})();
(function(){
  function card(el){return el.closest(".ci-ed__row")}
  document.addEventListener("click",function(e){
    var opt=e.target.closest(".ci-ed__opt");
    if(opt&&!opt.hasAttribute("data-co-variant")){
      var c=card(opt);
      if(!c)return;
      c.querySelectorAll(".ci-ed__opt").forEach(function(b){b.classList.remove("is-on")});
      opt.classList.add("is-on");
      var add=c.querySelector("[data-ed-add]");
      if(add)add.setAttribute("data-ed-add",opt.getAttribute("data-ed-variant"));
      var pr=c.querySelector("[data-ed-price]");
      if(pr&&opt.getAttribute("data-ed-price-raw"))pr.textContent=opt.getAttribute("data-ed-price-raw");
      return;
    }
    var copt=e.target.closest("[data-co-variant]");
    if(copt){
      var box=copt.closest(".ci-co__box");
      var pick=copt.getAttribute("data-co-pick")||"b";
      box.querySelectorAll('[data-co-pick="'+pick+'"]').forEach(function(b){b.classList.remove("is-on")});
      copt.classList.add("is-on");
      var cb=box.querySelector("[data-co-add-a]");
      if(cb)cb.setAttribute("data-co-add-"+pick,copt.getAttribute("data-co-variant"));
      if(pick==="a"){var lb=box.querySelector(".ci-co__loyal [data-ed-add]");if(lb)lb.setAttribute("data-ed-add",copt.getAttribute("data-co-variant"))}
      return;
    }
    var btn=e.target.closest("[data-ed-add],[data-co-add-a]");
    if(!btn||btn.disabled)return;
    e.preventDefault();
    var items=[];
    if(btn.hasAttribute("data-co-add-a")){
      items.push({id:parseInt(btn.getAttribute("data-co-add-a"),10),quantity:1});
      items.push({id:parseInt(btn.getAttribute("data-co-add-b"),10),quantity:1});
    }else{
      var id=btn.getAttribute("data-ed-add");
      if(!id)return;
      items.push({id:parseInt(id,10),quantity:1});
    }
    var old=btn.textContent;
    btn.disabled=true;
    btn.textContent="…";
    var row=btn.closest("[data-ed-discount]");
    var pre=Promise.resolve();
    if(row&&row.getAttribute("data-ed-discount")){
      pre=fetch("/discount/"+encodeURIComponent(row.getAttribute("data-ed-discount")),{credentials:"same-origin"}).catch(function(){});
    }
    pre.then(function(){return fetch("/cart/add.js",{method:"POST",credentials:"same-origin",
      headers:{"Content-Type":"application/json","Accept":"application/json"},
      body:JSON.stringify({items:items})})})
    .then(function(r){if(!r.ok)throw new Error("add");return r.json()})
    .then(function(){
      btn.disabled=false;btn.textContent=old;
      document.dispatchEvent(new CustomEvent("ajaxProduct:added"));
    })
    .catch(function(){
      btn.disabled=false;btn.textContent=old;
      window.location.href="/cart";
    });
  });
})();
